import { request } from '@gameforge/http-client'

export const loadLocales = async () =>
  request(window.origin)
    .get(`/translations/locales.json`)
    .then(res => res.json<string[]>())
